import { isEmpty } from 'lodash';

export const revertPhoneMask = (string) => {
  if (isEmpty(string)) {
    return string;
  }

  return string.replace(/[()]/g, '').replace(/\s/g, '');
};
